import { render, staticRenderFns } from "./TaskBarDrawer.vue?vue&type=template&id=2e7b622f&scoped=true&"
import script from "./TaskBarDrawer.vue?vue&type=script&lang=js&"
export * from "./TaskBarDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TaskBarDrawer.vue?vue&type=style&index=0&id=2e7b622f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7b622f",
  null
  
)

export default component.exports